import { FC } from 'react';
import KpiCard from '@/components/admin/KpiCard';
import type { KpiDre } from '@/utils/equiplexDre';
import { fmtBRLCompacto, fmtDesvio, fmtPct } from '@/utils/painelFormat';

function comparacao(k: KpiDre, parcial: boolean): string {
  // Mês com o contábil ainda sendo lançado contra a média de meses fechados só mostra o que falta lançar.
  if (parcial) return 'mês parcial: sem comparação';
  return k.varMedia === null ? 'sem média de 3 meses' : `${fmtDesvio(k.varMedia)} sobre a média de 3 meses`;
}

function sub(k: KpiDre, parcial: boolean): string {
  const partes: string[] = [];
  if (k.margem !== null) partes.push(`margem ${fmtPct(k.margem)}`);
  partes.push(comparacao(k, parcial));
  return partes.join(' · ');
}

/** Os quatro números que a reunião olha primeiro, no mês escolhido. */
const KpisDre: FC<{ kpis: KpiDre[]; parcial?: boolean }> = ({ kpis, parcial = false }) => (
  <div className="grid grid-cols-[repeat(auto-fit,minmax(15rem,1fr))] gap-4" data-testid="dre-kpis">
    {kpis.map((k) => (
      <KpiCard key={k.key} icon={k.icone} value={fmtBRLCompacto(k.valor)} label={k.rotulo} sublabel={sub(k, parcial)} />
    ))}
  </div>
);

export default KpisDre;
